// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img_box[data-v-aad3f042]{padding:5px 5px;border:1px solid #ccc;cursor:pointer}", ""]);
// Exports
module.exports = exports;
